import { createFileRoute } from '@tanstack/react-router';
import { AssistantCreation } from '../../../../features/assistantform/pages/AssistantCreation';

export const Route = createFileRoute('/_app/assistant/create/')({
  component: RouteComponent,
});

function RouteComponent() {
  return <AssistantCreation />;
}
